var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16V10H5L12 3L19 10H15V16H9ZM5 20V18H19V20H5Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.aae6a62e8602d7ff8cfa7164db6c98eb.svg";
export { ForwardRef as ReactComponent };